import { BizyPageContext } from '../store/use-bizy-page-context-store';

interface BizyRouteEntry {
	prefix: string;
	context: BizyPageContext;
	/** Short label for conversation history (defaults to context.pageName) */
	shortName?: string;
}

const HOME_CONTEXT: BizyPageContext = { pageName: 'Home', pageType: 'home' };
const DEFAULT_CONTEXT: BizyPageContext = { pageName: 'Bonusly', pageType: 'feed' };

/**
 * Declarative mapping from route prefixes to Bizy page context.
 *
 * Order matters: more specific prefixes must appear before their parents
 * (e.g. `/growth/goals` before `/growth`).
 *
 * When adding Bizy support for a new page, add an entry here.
 */
export const BIZY_ROUTE_CONFIG: BizyRouteEntry[] = [
	{ prefix: '/meet', context: { pageName: '1:1 Meetings', pageType: '1on1' }, shortName: '1:1' },
	{ prefix: '/growth/goals', context: { pageName: 'Goals', pageType: 'goals' } },
	{ prefix: '/growth/recap-review', context: { pageName: 'Recaps', pageType: 'feed' } },
	{ prefix: '/growth/feedback', context: { pageName: 'Advice', pageType: 'feed' } },
	{ prefix: '/growth', context: { pageName: 'Growth', pageType: 'feed' } },
	{ prefix: '/incentives', context: { pageName: 'Incentives', pageType: 'feed' } },
	{ prefix: '/rewards', context: { pageName: 'Rewards', pageType: 'rewards' } },
	{ prefix: '/team', context: { pageName: 'Team', pageType: 'team' } },
	{ prefix: '/bonuses', context: HOME_CONTEXT },
	{ prefix: '/invite', context: HOME_CONTEXT },
	{ prefix: '/bookmark', context: HOME_CONTEXT },
];

export function resolvePageContext(pathname: string): BizyPageContext {
	if (pathname === '/') return HOME_CONTEXT;

	for (const route of BIZY_ROUTE_CONFIG) {
		if (pathname.startsWith(route.prefix)) {
			return route.context;
		}
	}

	return DEFAULT_CONTEXT;
}

/** Short display label for a route path, used in conversation history lists. */
export function getPageDisplayName(pathname: string | null): string {
	if (!pathname) return 'Bonusly';
	if (pathname === '/') return 'Home';

	for (const route of BIZY_ROUTE_CONFIG) {
		if (pathname.startsWith(route.prefix)) {
			return route.shortName ?? route.context.pageName;
		}
	}

	return 'Bonusly';
}
